<template>
  <v-container class="pa-2 pt-5">
    <v-btn
      color="#ADADAD"
      dark
      class="orderRoomBtn"
      large
      fab
      @click="$emit('bookingDate', calendarDay)"
    >
      <v-row
        no-gutters
        justify="center"
        align="start"
      >
        <v-icon>mdi-calendar-edit</v-icon>
      </v-row>
      <!-- <v-row no-gutters justify="center" align="start"> -->
      <p class="order mb-2">
        立即訂位
      </p>
      <!-- </v-row> -->
    </v-btn>
    <v-row
      no-gutters
      justify="space-between"
      align="center"
    >
      <v-btn
        :disabled="prevDisabled"
        class="font-weight-bold calendar-btn pa-0"
        text
        dens
        small
        color="secondary"
        @click="prev"
      >
        <v-icon small>
          mdi-menu-left
        </v-icon>
        {{
          $root.moment(calendarDay).subtract(1, "months").format("YYYY年MM月")
        }}
      </v-btn>
      <v-toolbar-title class="calendar-title">
        {{ `${$root.moment(calendarDay).format("MM")}月` }}
      </v-toolbar-title>
      <v-btn
        class="font-weight-bold calendar-btn pa-0"
        text
        small
        color="secondary"
        @click="next"
      >
        {{ $root.moment(calendarDay).add(1, "months").format("YYYY年MM月") }}
        <v-icon small>
          mdi-menu-right
        </v-icon>
      </v-btn>
    </v-row>
    <!-- <v-sheet height="500"> -->
    <v-calendar
      id="orderRoomCalendar"
      ref="calendar"
      v-model="calendarDay"
      type="month"
      locale="zh"
      :weekday-format="weekday"
      @click:day="changeDate"
    >
      <template
        v-slot:day-label="{ day, date }"
        class="my-0"
      >
        <p
          :class="`order-day mb-1 ${date}`"
          :style="`color:${dayDisabled(date).color};`"
        >
          {{ day }}
        </p>
      </template>
      <template v-slot:day="{ date }">
        <v-row
          no-gutters
          justify="center"
        >
          <v-btn
            v-if="getEmpty(date).text !== ''"
            class="font-weight-bold mb-2"
            color="primary"
            fab
            elevation="4"
            x-small
            :outlined="getEmpty(date).isFull"
            :disabled="getEmpty(date).isFull"
          >
            {{ getEmpty(date).text }}
          </v-btn>
        </v-row>
      </template>
    </v-calendar>
    <div v-if="emptyRoomList.length > 1">
      <v-row
        no-gutters
        justify="center"
        class="mb-3 mt-6"
      >
        <h3>{{ calendarDay }}空位狀況</h3>
      </v-row>
      <v-card
        elevation="2"
        class="mt-3"
      >
        <v-data-table
          :headers="emptyInfoHeader"
          :items="emptyRoomList"
          :mobile-breakpoint="0"
          hide-default-footer
        />
      </v-card>
    </div>
    <!-- </v-sheet> -->
  </v-container>
</template>

<script>
import $ from 'jquery'

export default {
  data () {
    return {
      isShowTable: false,
      chooseDate: '',
      prevDisabled: false,
      startMenu: false,
      calendarDay: this.$route.params.date,
      now: '',
      calendarTime: '',
      emptyRoomList: [],
      emptyInfoHeader: [
        { value: 'name', text: '營地名稱' },
        { value: 'total', text: '總數量' },
        { value: 'empty', text: '剩餘' }
      ],
      roomsInfo: {
        '20220512': {
          roomsEmpty: 0,
          roomsList: [
            { name: 'A1區-4帳包區', total: 1, empty: 0 },
            { name: 'A2區-4帳包區', total: 1, empty: 0 },
            { name: 'B區-3帳包區', total: 1, empty: 0 }
          ]
        },
        '20220513': {
          roomsEmpty: 3,
          roomsList: [
            { name: 'A1區-4帳包區', total: 1, empty: 1 },
            { name: 'A2區-4帳包區', total: 1, empty: 1 },
            { name: 'B區-3帳包區', total: 1, empty: 1 }
          ]
        },
        '20220514': {
          roomsEmpty: 3,
          roomsList: [
            { name: 'A1區-4帳包區', total: 1, empty: 1 },
            { name: 'A2區-4帳包區', total: 1, empty: 1 },
            { name: 'B區-3帳包區', total: 1, empty: 1 }
          ]
        }
      }
    }
  },
  mounted () {
    this.changeDate({ date: this.$route.params.date })
    this.calendarDay = this.$route.params.date
    // roomsInfo[$root.moment(chooseDate).format('YYYYMMDD')].roomsList
    this.roomList()

    this.minDate()
    //  console.log("$refs.calendar", this.$refs.calendar)
  },

  methods: {
    roomList () {
      let roomInfo =
        this.roomsInfo[this.$root.moment(this.calendarDay).format('YYYYMMDD')]
      // debugger
      // if (roomInfo) {
      this.emptyRoomList = roomInfo ? roomInfo.roomsList : []
      // }
    },
    dayDisabled (day) {
      let dayTime = this.$root.moment(day).format('YYYYMMDD')
      let now = this.$root.moment().format('YYYYMMDD')

      if (dayTime < now) {
        return { isShow: false, color: '#c5c5c5' }
      } else {
        return { isShow: true, color: '' }
      }
    },
    getLabel (item) {
      console.log('getLabel', item)
    },
    changeDate (item) {
      let date
      if (item) {
        date = this.$root.moment(item.date).format('YYYYMMDD')
      }
      // debugger
      if (this.roomsInfo[date] && this.roomsInfo[date].roomsEmpty > 0) {
        // this.chooseDate = item.date
        this.calendarDay = item.date
        $('.v-calendar-weekly__day').css('background', '')

        $(`.${this.calendarDay}`)
          .parents('.v-calendar-weekly__day')
          .css('background', '#FFEEDD')
        this.roomList()
      }

      // console.log("$refs.calendar", this.$refs.calendar);
      // console.log("changeDate", item);
    },
    prev () {
      this.$refs.calendar.prev()
      this.minDate()
      this.roomList()
      setTimeout(() => {
        this.changeDate({ date: this.calendarDay })
      }, 1)
    },
    next () {
      this.$refs.calendar.next()
      this.minDate()
      this.roomList()
      setTimeout(() => {
        this.changeDate({ date: this.calendarDay })
      }, 1)
    },
    minDate () {
      this.calendarTime = this.$root.moment(this.calendarDay).format('YYYYMM')
      this.now = this.$root.moment().format('YYYYMM')

      if (this.calendarTime === this.now) {
        this.prevDisabled = true
      } else {
        this.prevDisabled = false
      }
    },
    getEmpty (date) {
      date = this.$root.moment(date).format('YYYYMMDD')
      if (this.roomsInfo[date]) {
        return this.roomsInfo[date].roomsEmpty === 0
          ? { text: '滿', isFull: true }
          : { text: this.roomsInfo[date].roomsEmpty, isFull: false }
      }

      return { text: '' }
    },
    weekday (x) {
      let formatWeek = {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        0: '日'
      }
      return formatWeek[x.weekday]
    }
    // showIntervalLabel(interval) {
    //   return interval.minute === 0;
    // },
  }
}
</script>

<style lang="scss" scoped>
.orderRoomBtn {
  position: fixed;
  bottom: 105px;
  z-index: 1;
  right: 5px;
}
.order{
  font-size:13px
}
.order-day {
  font-size: 12px;
}
.calendar-title {
  font-size: 26px;
}
.calendar-btn {
  font-size: 14px;
}
#orderRoomCalendar {
  height: auto;
}
</style>
<style lang="scss" >
#orderRoomCalendar .v-calendar-weekly__week {
  flex: none;
  min-height: 67px;
  // max-height: 85px;
}
.orderRoomBtn .v-btn__content{
  display: grid;

}
</style>
